export function hasFileFormatInFileName(fileName: string | null) {
  return Boolean(fileName && fileName.split('.').length > 1);
}
